const ls = window.localStorage

export default {
  get (key) {
    let userLists = JSON.parse(ls.getItem(key) || '{}')
    return userLists;
  },
  save (key, data) {
    ls.setItem(key,JSON.stringify(data))
  },
  remove (key) {
    ls.removeItem(key)
  }
}



// WEBPACK FOOTER //
// ./src/utils/ls.js